import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { editUser } from '../../redux/users/userSlice'
import { useNavigate, useParams } from 'react-router-dom'

import TextField from '../../components/forms/TextField'
import PasswordField from '../../components/forms/PasswordField'
import EmailField from '../../components/forms/EmailField'

import { getUsers } from '../../redux/users/userSlice'
import { clearError } from '../../redux/errors/ErrorSlice'

import SelectField from '../../components/forms/SelectField'
import ErrorMessage from '../../components/ErrorMessage'

export default function UsersEdit() {
    const [userForm, setUserForm] = useState({})
    const [submitted, setSubmitted] = useState(false)
    const [user, setUser] = useState({})

    const [companies, setCompanies] = useState([])
    
    const userRedux = useSelector(state => state.User)
    const authRedux = useSelector(state => state.Auth)
    const errorRedux = useSelector(state => state.Error)
    const companyRedux = useSelector(state => state.Company)
    const locationRedux = useSelector(state => state.Location)

    const dispatch = useDispatch()

    const params = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        if (userRedux.isButtonLoading) {
            dispatch(clearError())
        }
        if (submitted && !userRedux.isButtonLoading && !errorRedux.errorMessage) {
            navigate(-1)
        }
    }, [userRedux.isButtonLoading])

    useEffect(() => {
        const temp = companyRedux.companies.map( el => Object({ label: el.name, value: el.id }))
        setCompanies(temp)
    }, [companyRedux.companies])

    useEffect(() => {
        if (!submitted) {
            dispatch(clearError())
        }
    }, [submitted])

    useEffect(() => {
        if (userRedux.users.length === 0) {
            dispatch(getUsers({ companyId: params.companyId }))
        }

        const currentUser = userRedux.users.filter(user => user.id === params.userId).pop()
        setUser(currentUser)
    }, [params.userId])

    const submitUserForm = (ev) => {
        ev.preventDefault()
        setSubmitted(true)

        let hasError = false

        for (const key in userForm) {
            
            if (userForm[key].isRequired && !userForm[key].fieldValue || userForm[key].error) {
                hasError = true
                break
            } else {
                hasError = false
            }
        }

        if (!hasError) {
            const name = userForm.name.fieldValue
            const email = userForm.email.fieldValue
            const password = userForm.password.fieldValue

            const locationId = authRedux.user.claims.role === 0 || authRedux.user.claims.role == 1 ? userForm?.location?.fieldValue : params.locationId
            const companyId = authRedux.user.claims.role === 0 ? userForm.company.fieldValue : params.companyId

            const role = userForm?.role?.fieldValue

            dispatch(editUser({
                id: params.userId,
                name: name,
                email: email,
                password: password,
                companyId: companyId,
                ...locationId && {
                    locationId: locationId
                },
                ...authRedux.user.claims.role === 0 ? {
                    role: role
                } : {
                    role: 2
                }
            }))

        }
    }

    return <form onSubmit={submitUserForm}>
        <div className='flex mb-20'>
            <button type="button" onClick={() => navigate(-1)} className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 9l-3 3m0 0l3 3m-3-3h7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>

                <span className='ml-2'>Back</span>
            </button>
        </div>

        <TextField
            fieldName="name"
            label="User Name"
            defaultValue={user.name}
            isSubmitted={submitted}
            isRequired
            onChange={e => setUserForm(userForm => ({ ...userForm, name: e }))}
        />

        <EmailField
            fieldName="email"
            label="User Email"
            defaultValue={user.email}
            isSubmitted={submitted}
            isRequired
            onChange={e => setUserForm(userForm => ({ ...userForm, email: e }))}
        />

        <PasswordField
            label="User Password"
            fieldName="password"
            defaultValue={user.password}
            isSubmitted={submitted}
            onChange={e => setUserForm(userForm => ({ ...userForm, password: e }))}
        />

        {
            authRedux.user.claims.role === 0 ? <SelectField
                legend="Choose a role"
                label="User Role"
                fieldName="role"
                defaultValue={user.role}
                isSubmitted={submitted}
                isRequired
                onChange={e => setUserForm(userForm => ({ ...userForm, role: e }))}
                options={
                    [
                        { label: "Super Admin", value: 0 },
                        { label: "Manager", value: 1 },
                        { label: "Staff", value: 2 }
                    ]}
            /> : null
        }

        {
            userForm?.role?.fieldValue == 0 || userForm?.role?.fieldValue == 1 || userForm?.role?.fieldValue == 2 ? <div className='mt-8'> <SelectField
                label="Company"
                legend="Choose Company"
                fieldName="company"
                isRequired
                defaultValue={user?.company}
                isSubmitted={submitted}
                onChange={e => setUserForm(userForm => ({ ...userForm, company: e }))}
                options={companies} /> </div> : null
        }
        {
            userForm?.role?.fieldValue == 2 || authRedux.user.claims.role == 1 ? <div className='mt-8'>
                <SelectField
                    label="Location"
                    legend="Choose Location"
                    defaultValue={user?.location}
                    fieldName="location"
                    isRequired
                    isSubmitted={submitted}
                    onChange={e => setUserForm(userForm => ({ ...userForm, location: e }))}
                    options={locationRedux.locations.map(el => Object({ label: el.name, value: el.id }))}
                />
            </div> : null
        }

        <div className='mt-3'>
            <button
                type="submit"
                disabled={userRedux.isButtonLoading}
                className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto">
                {
                    userRedux.isButtonLoading ? <span className='ml-2'>Saving Changes...</span> : <>  <span>Save Changes</span></>
                }

            </button>
        </div>

        <div className='mt-3'>
            {
                errorRedux.errorMessage ? <ErrorMessage message={errorRedux.errorMessage} /> : null
            }
        </div>

    </form>
}